import { DOCUMENT, Location } from '@angular/common';
import { Component, Inject, Renderer2 } from '@angular/core';
import { Router } from '@angular/router';
import { App } from '@capacitor/app';
import { isPlatform } from '@ionic/angular';
import { AndroidPluginService } from './services/android/android-plugin.service';
import { CredentialService } from './services/credential/credential.service';
import { FirebaseService } from './services/firebase/firebase.service';
import { PingService } from './services/ping/ping.service';
import { UserAuthService } from './services/user/user-auth.service';
import { EmergencyService } from './views/pages/main-app/pages/emergency/services/emergency.service';
import { START_PAGE_KEY } from './views/pages/start-page/start-page.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {

  constructor(
    private router: Router,
    private location: Location,
    private renderer2: Renderer2,
    @Inject(DOCUMENT) private _document: any,
    //private cred: CredentialService,
    // private firebase: FirebaseService,
    // private user: UserAuthService,
    // private androidPluginSvc: AndroidPluginService,
    // private ping: PingService,
    // private emergency: EmergencyService,
  ){
    this.redirectToStartPage();
    this.initBackButtonOnMobile();
    //this.initMidtrans();
  }

  private redirectToStartPage(){
    if (isPlatform("android") && isPlatform("capacitor")){
      if (!sessionStorage.getItem(START_PAGE_KEY)) this.router.navigate(['start-page']);
    }
  }

  /*
  private initMidtrans(){
    const s = this.renderer2.createElement('script');
    s.type = 'text/javascript';
    s.src = 'https://app.midtrans.com/snap/snap.js';
    s.setAttribute('data-client-key', this.cred.getMidtransKey());
    this.renderer2.appendChild(this._document.head, s);
  }
  */

  //Exit app if can't go back
  private  async initBackButtonOnMobile(){
    if (isPlatform("android") && isPlatform("capacitor")) {
      let a = await App.addListener('backButton', (event) => {
        if (!event.canGoBack) {
          App.exitApp();
        } else {
          this.location.back();
        }
      })
    }
  }
}
